module.exports = __webpack_public_path__ + "e5b0152f70c6e20eee87f0b118256e6a.svg";